import { useId, useState } from 'react';

export function InvestigationExpandableText({
  text,
  maxCharacters,
  className = '',
}: {
  text: string;
  maxCharacters: number;
  className?: string;
}) {
  const [expanded, setExpanded] = useState(false);
  const contentId = useId();
  const normalizedText = text.trim();
  const collapsed = truncateAtWordBoundary(normalizedText, maxCharacters);
  const isTruncated = collapsed.length < normalizedText.length;
  const visibleText = expanded || !isTruncated ? normalizedText : `${collapsed}…`;

  return (
    <div className={`r42-investigation-expandable-text${className ? ` ${className}` : ''}`}>
      <p id={contentId}>{visibleText}</p>
      {isTruncated ? (
        <button
          type="button"
          className="r42-investigation-read-more"
          aria-expanded={expanded}
          aria-controls={contentId}
          onClick={() => setExpanded((value) => !value)}
        >
          {expanded ? 'Show less' : 'Read more'}
        </button>
      ) : null}
    </div>
  );
}

function truncateAtWordBoundary(text: string, maxCharacters: number) {
  const normalized = text.trim();
  if (normalized.length <= maxCharacters) return normalized;
  const candidate = normalized.slice(0, Math.max(1, maxCharacters + 1));
  const lastWhitespace = candidate.search(/\s+\S*$/);
  const cutoff = lastWhitespace > Math.floor(maxCharacters * 0.65) ? lastWhitespace : maxCharacters;
  return normalized.slice(0, cutoff).trimEnd();
}
